'use client';

import { useSearchParams } from 'next/navigation';
import type { FC, ReactNode } from 'react';
import { BaseLineLeft } from '@/app/components/icons/BaseLineLeft';
import { useDevice, useGoBack } from '@/app/hooks';
import { cn } from '@/app/utils';

export const BackContent: FC<{
  className?: string;
  size?: number;
  children?: ReactNode;
  /** 强制使用浏览器原生 history.back() 返回 */
  forceBrowserBack?: boolean;
}> = ({ className, size = 6, children, forceBrowserBack }) => {
  const searchParams = useSearchParams();
  const headless = searchParams.get('headless');
  const { isMobile, isLenovoMini } = useDevice();
  const goBack = useGoBack({ forceBrowserBack });

  if ((!isMobile && !isLenovoMini) || headless === 'false') {
    return null;
  }

  return (
    <div
      className={cn('flex cursor-pointer items-center gap-2 font-medium text-white text-xl', className)}
      onClick={goBack}
    >
      <BaseLineLeft className={cn(`size-${size}`)} />
      {children}
    </div>
  );
};
